var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("规则管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("规则列表"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "标题" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入标题",
                                  },
                                  model: {
                                    value: _vm.ruleForm.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "name", $$v)
                                    },
                                    expression: "ruleForm.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择状态" },
                                    model: {
                                      value: _vm.ruleForm.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "status", $$v)
                                      },
                                      expression: "ruleForm.status",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "停用", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "启用", value: "1" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList()
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-table",
              {
                ref: "scrollTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "编号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "name", label: "标题", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "分类", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.type == 0
                            ? _c("span", [_vm._v("截单设置")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.type == 1
                            ? _c("span", [_vm._v("派单设置")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.type == 2
                            ? _c("span", [_vm._v("回访设置")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "规则内容", align: "center", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.type == 0
                            ? _c("div", [
                                _c("div", [
                                  _vm._v("\n                发布人类型："),
                                  _c("span", { staticClass: "decoration" }, [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.cutRule.publisherType == 0
                                          ? "所有"
                                          : scope.row.cutRule.publisherType == 1
                                          ? "个人"
                                          : "企业"
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v("\n                地区："),
                                  _c("span", { staticClass: "decoration" }, [
                                    _vm._v(_vm._s(scope.row.cutRule.cityName)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v("\n                总金额："),
                                  _c("span", { staticClass: "decoration" }, [
                                    _vm._v(
                                      _vm._s(scope.row.cutRule.moneyValue)
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v("\n                截停时间："),
                                  _c("span", { staticClass: "decoration" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("maxTime")(
                                          scope.row.cutRule.cutTimeValue
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.type == 1
                            ? _c("div", [
                                _c("div", [
                                  _vm._v("\n                显示结束时间："),
                                  _c("span", { staticClass: "decoration" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("maxTime")(
                                          scope.row.dispatchRule
                                            .dispatchEndTimeValue
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.type == 2
                            ? _c("div", [
                                _c("div", [
                                  _vm._v("\n                回访时间要求："),
                                  _c("span", { staticClass: "decoration" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("maxTime")(
                                          scope.row.followupRule
                                            .followupRequireTimeValue
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "发布时间", align: "center", width: "160" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.publishTime))]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status == 0
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("停用"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("启用"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", align: "center", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "disAround" }, [
                            scope.row.status == 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn greenColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.stop(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                启用\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status == 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn redColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.stop(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                停用\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.edit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "630px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticStyle: { margin: "0 auto" },
              attrs: {
                "label-position": "right",
                model: _vm.ruleForm1,
                rules: _vm.rules,
              },
            },
            [
              _vm.type == 0
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "发布人类型", prop: "type" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.ruleForm1.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "type", $$v)
                                },
                                expression: "ruleForm1.type",
                              },
                            },
                            _vm._l(_vm.options, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发布区域", prop: "region" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.ruleForm1.region,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "region", $$v)
                                },
                                expression: "ruleForm1.region",
                              },
                            },
                            _vm._l(_vm.city, function (item) {
                              return _c("el-option", {
                                key: item.adcode,
                                attrs: { label: item.name, value: item.adcode },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "金额大于", prop: "money" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { placeholder: "请输入金额" },
                              model: {
                                value: _vm.ruleForm1.money,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "money", $$v)
                                },
                                expression: "ruleForm1.money",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("以上"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "截停时间", prop: "time" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { placeholder: "请输入截停时间" },
                              model: {
                                value: _vm.ruleForm1.time,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "time", $$v)
                                },
                                expression: "ruleForm1.time",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("分钟"),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                flex: "none",
                                "margin-left": "10px",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("maxTime")(
                                      _vm.ruleForm1.time == ""
                                        ? ""
                                        : _vm.ruleForm1.time
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type == 1
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "截停时间", prop: "time1" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { placeholder: "请输入截停时间" },
                              model: {
                                value: _vm.ruleForm1.time1,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "time1", $$v)
                                },
                                expression: "ruleForm1.time1",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("分钟"),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                flex: "none",
                                "margin-left": "10px",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("maxTime")(
                                      _vm.ruleForm1.time1 == ""
                                        ? ""
                                        : _vm.ruleForm1.time1
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type == 2
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "截停时间", prop: "time2" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { placeholder: "请输入截停时间" },
                              model: {
                                value: _vm.ruleForm1.time2,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "time2", $$v)
                                },
                                expression: "ruleForm1.time2",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("分钟"),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                flex: "none",
                                "margin-left": "10px",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("maxTime")(
                                      _vm.ruleForm1.time2 == ""
                                        ? ""
                                        : _vm.ruleForm1.time2
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm1("ruleForm")
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }